import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, nextConfig, config }) =>
    present(
      repository
        .updateProjectConfiguration(project, nextConfig)
        .then(() => ({ project, config: nextConfig }))
        .catch((e) => Promise.reject({ project, nextConfig, config })),
    );
}

export type { Interactor };

export { createInteractor };
